var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M22.8,7.7c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S24.4,7.7,22.8,7.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 13.5,
  y: 8.5,
  fill: "#505050",
  width: 1.8,
  height: 11.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M24.7,14.3c-2.8,0.1-3.3,4-3.4,5.8h11.1C31.6,18.1,29.4,14.1,24.7,14.3z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#505050",
  points: "4,37.3 41,37.3 41,35.2 36.4,35.2 36.4,21.4 8.8,21.4 8.8,35.2 4,35.2  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M20.5,20.1c0-0.9-0.7-1.7-1.7-1.7c-0.1,0-0.1,0-0.2,0c-0.9-0.1-1.8,0.6-1.9,1.5c0,0.1,0,0.1,0,0.2H20.5z"
}));

function SvgCubicles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubicles);
export default __webpack_public_path__ + "static/media/cubicles.69b159fbe8c494e52690c1569bbb00d5.svg";
export { ForwardRef as ReactComponent };